import React from "react";
import { BsShieldCheck } from "react-icons/bs";
import { BsPeople } from "react-icons/bs";
import { ImStarEmpty } from "react-icons/im";
import { MdOutlineWifiCalling3 } from "react-icons/md";
import { Link } from "react-router-dom";
import paymentOptions from "../images/paymentOptions.jpg";
import { GrFacebookOption } from "react-icons/gr";
import { BsInstagram } from "react-icons/bs";
import { GrTwitter } from "react-icons/gr";
import { HiOutlineMail } from "react-icons/hi";
import { BiPhone } from "react-icons/bi";
import { FiMapPin } from "react-icons/fi";
import { FiInfo } from "react-icons/fi";

function Footer() {
  return (
    <>
      <footer className="footer-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div className="abcd">
                <div className="row">
                  <div className="col-12 col-md-3 col-lg-3 text-center">
                    <div>
                      <BsShieldCheck className="shield-icon" />
                    </div>
                    <p>100% Secure Payment</p>
                  </div>
                  <div className="col-12 col-md-3 col-lg-3 text-center">
                    <div>
                      <BsPeople className="shield-icon" />
                    </div>
                    <p>2000+ Satisfied Client</p>
                  </div>
                  <div className="col-12 col-md-3 col-lg-3 text-center">
                    <div>
                      <ImStarEmpty className="shield-icon" />
                    </div>
                    <p>Money-Back guarantee</p>
                  </div>
                  <div className="col-12 col-md-3 col-lg-3 text-center">
                    <div>
                      <MdOutlineWifiCalling3 className="shield-icon" />
                    </div>
                    <p>24x7 Calling Helpline</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row footer-section">
            <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
              <div className="footer-col">
                <h5 className="footer-headings">COMPANY</h5>
                <ul>
                  <li>
                    <Link className="footer-link" to="/aboutUs">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link className="footer-link" to="/PrivacyPolicy">
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link className="footer-link" to="/TermsAndConditions">
                      Terms & Conditions
                    </Link>
                  </li>
                  <li>
                    <Link className="footer-link" to="/RefundPolicy">
                      Refund Policy
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
              <div className="footer-col">
                <h5 className="footer-headings">QUICK LINKS</h5>
                <ul>
                  <li>
                    <Link className="footer-link" to="/numbers">
                      Vip Number
                    </Link>
                  </li>
                  <li>
                    <Link className="footer-link" to="/contactUs">
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link className="footer-link" to="/Faq">
                      FAQ
                    </Link>
                  </li>
                  <li>
                    <Link className="footer-link" to="/Blogs">
                      Blogs
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
              <div className="footer-col15">
                <h5 className="footer-headings">CONTACT US</h5>
                <ul>
                  <div className="d-flex a-links">
                    <li className="contactus-footer-icons">
                      <HiOutlineMail />
                    </li>
                    <li className="contactus-footer-txt">
                      <a href="mailto:info@vipnumberstudio.com">
                        info@vipnumberstudio.com
                      </a>
                    </li>
                  </div>
                  <div className="d-flex a-links">
                    <li className="contactus-footer-icons">
                      <BiPhone />
                    </li>
                    <li className="contactus-footer-txt">
                      <a href="tel:+918562944944">8562 944 944</a>
                    </li>
                  </div>
                  <div className="d-flex">
                    <li className="contactus-footer-icons">
                      <FiMapPin />
                    </li>
                    <li className="contactus-footer-txt">
                      Shop No.2 Mahape Road Opp Regal Restaurant Shilphata
                      Thane-421204
                    </li>
                  </div>
                  <div className="d-flex">
                    <li className="contactus-footer-icons">
                      <FiInfo />
                    </li>
                    <li className="contactus-footer-txt">
                      GST No : 27LTMPS0637K1ZV
                    </li>
                  </div>
                </ul>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
              <div className="footer-col1 tags">
                <h5 className="footer-headings">POPULAR SEARCHES</h5>
                <ul>
                  <li>Premium Number</li>
                  <li>Vip Number</li>
                  <li>Fancy Number</li>
                  <li>Special Digit Numbers</li>
                  <li>Year Numbers</li>
                  <li>Semi Mirror Numbers</li>
                  <li>Mirror Numbers</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row social-media-area">
            <div className="col-md-4 col-lg-4 col-col-xl-4">
              <div className="copyright-area">
                <p>
                  Copyright {new Date().getFullYear()} © MODERN TELECOM SALES
                  AND SERVICES
                  <br />
                  Designed by{" "}
                  <a
                    href="https://anadigitalmedia.in/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ANA Digital Media
                  </a>
                </p>
              </div>
            </div>
            <div className="col-md-4 col-lg-4 col-col-xl-4 text-lg-center">
              <div className="icons-area">
                <ul>
                  {/* <li>
                    <a href="#">
                      <GrFacebookOption />
                    </a>
                  </li> */}
                  <li>
                    <a href="https://www.instagram.com/vipnumberstudio">
                      <BsInstagram />
                    </a>
                  </li>
                  {/* <li>
                    <a href="#">
                      <GrTwitter />
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
            <div className="col-md-4 col-lg-4 col-col-xl-4 text-lg-end">
              <div className="payment-section">
                <img
                  src={paymentOptions}
                  className="img-fluid payment-image"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
